import FormInput from "components/QuickPurchasePage/Form/FormInput"
import styled, { css } from "styled-components"

export const errorAndFocusStyles = `
// Focus and Error Handling

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    box-shadow: none !important;
  }

  .MuiOutlinedInput-root {
    border-radius: 8px;
    box-shadow: none;


    fieldset {
      border: 1px solid #e5e5e5; // Gray border when there's no focus or error
      outline: none;
    }

    &.Mui-error {
      fieldset {
        border: 1px solid #db0007; // Red border for error
      }

      input {
        font-size: 20px;
      }
    }

    &:focus-within {
      fieldset {
        border: 1px solid #f7c600; // Yellow border on focus even with error
        color: var(--Black, var(--Primary-Black, #000));
      }
    }

    &.Mui-error:focus-within {
      fieldset {
        border: 1px solid #f7c600; // Ensure yellow border on focus with error
        color: var(--Black, var(--Primary-Black, #000));
      }
    }
  }

  .MuiFormHelperText-root.Mui-error {
    font-size: 14px;
    margin-top:0;
  }
`

export const GenericInput = styled(FormInput)<{
  $width?: string
  $height?: string
  $mobileWidth?: string
  $hasIcon?: boolean
  endIcon?: any
  $unicodeBidi?: string
}>`
  input[type="email"] {
    font-size: 20px;
    font-family: Speedee, NarkisBlock;
    direction: ltr;
    text-align: right;
  }

  .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl {
    width: ${(p) => p?.$width || "312"}px;
    height: ${(p) => (p?.$height ? p?.$height : "56")}px;
    ${(p) =>
      p.multiline
        ? css`
            height: auto;
            min-height: ${p?.$height ? p?.$height : "56"}px;
          `
        : ""}
  }

  ${(p) => p.theme.breakpoints.down("sm")} {
    .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl {
      width: ${(p) => p?.$mobileWidth || "100%"};
    }
  }

  .MuiOutlinedInput-multiline {
    padding: 23px 0px 18.5px 0;

    textarea {
      padding: 0 8px;
    }
  }

  .MuiFormHelperText-root.MuiFormHelperText-contained {
    min-height: 15px;
  }

  .Mui-focused {
    border: 0;
    outline: 0;
    box-shadow: 0;
  }

  .MuiFormControl-root {
    ${(p) => p?.$mobileWidth && `width: ${p.$mobileWidth};`}
  }

  .MuiButtonBase-root.MuiIconButton-root {
    padding: 12px 0 12px 12px;
  }

  .MuiOutlinedInput-adornedStart {
    padding-right: 8px;
  }

  .MuiOutlinedInput-input {
    padding: 16px 8px 0px 8px;
    ${(p) => p?.$hasIcon && `padding: 16px 0 0px 8px;`}
    font-family: Speedee, NarkisBlock;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    &:not(:focus) {
      color: var(--Grey, #6f6f6f);
    }

    &:not(:focus) {
      color: #000;
    }

    &.Mui-error:not(:focus) {
      color: #000;
    }
  }

  .MuiInputLabel-root {
    font-size: 18px;
    font-family: NarkisBlock;
  }

  .MuiInputLabel-outlined {
    transform: translate(-8px, 16px);

    ${(p) => p.theme.breakpoints.down("sm")} {
      transform: translate(-8px, 18px);
    }
  }

  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(-8px, 8px) scale(1);
    ${(p) => p?.$hasIcon && `transform: translate(-44px, 8px) scale(1);`}
    color: var(--Grey, #757575);
    font-family: Speedee, NarkisBlock;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.21px;
  }

  ${(p) =>
    p?.$unicodeBidi &&
    `
      input {
        unicode-bidi: ${(p) => p.$unicodeBidi};
        text-align: right;

      }
    `}

  ${errorAndFocusStyles}
`
